/// <reference path="../../../tools/typings/tsd.d.ts"/>
/// <reference path="../components.ts"/>
/// <reference path="../../services/notes/notes.ts"/>
/// <reference path="../../services/internationalization/internationalization_data_dictionary.ts"/>

namespace DealerwareWebComponents {
    "use strict";

    import IDealerwareNotesCollection = DealerwareWebServices.IDealerwareNotesCollection;

    export class NotesDirectiveController {
        public static $inject : string[] = [
            '$timeout',
            'DealerwareNoteModel',
            '$scope',
            '$filter',
            '$state',
            'DataUtils',
            '$mobilityCompanyAuthentication',
            '$dealerwareLoading',
            '$dealerwareNotification',
            '$mdMedia',
            '$mdDialog',
            '$dealerwareInternationalizationData'
        ];

        public noteCollection : IDealerwareNotesCollection;
        public displayColumns : {}[];
        public loader: any;
        public labels: {};
        public gainsightId: string;

        public get collection() : any {
            return this.noteCollection;
        }

        public set collection(collection : any) {
            this.noteCollection = collection;
        }

        constructor(public $timeout : any,
                    public DealerwareNoteModel : any,
                    public $scope : any,
                    public $filter : any,
                    public $state: any,
                    public DataUtils: any,
                    public $mobilityCompanyAuthentication: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any,
                    public $mdMedia: any,
                    public $mdDialog: any,
                    public $dealerwareInternationalizationData: DealerwareWebServices.DealerwareInternationalizationData) {
            this.getLabels('vehicles');
            this.initColumns();
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then(function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                },
                function() {}
            );
        }

        public pageTransitionError(response: any) : void {
            this.loader.close();
            this.$dealerwareNotification.apiError(response);
        }

        public initColumns() : void {
            var _self = this,
                dataUtils = this.DataUtils.getInstance(),
                time_zone = this.$mobilityCompanyAuthentication.location.time_zone_name;

            this.displayColumns = [{
                key: 'created_at',
                header: 'Date',
                dataFilter: (ts: string) => {
                    return  this.$filter('filterInternationalizationDate')(dataUtils.formatTimestampSimple(ts, time_zone));
                }
            },{
                key: 'created_by_name',
                header: 'User',
                onClick: function(e: any, note: any) {
                    $(e.target).attr('href', _self.$state.href(
                        'root.private.application.employees.details',
                        { employeeId: note.data.created_by_id }
                    ));
                }
            },{
                key: 'title',
                header: 'Title',
            },{
                key: 'content',
                header: 'Note',
            }];
        }

        public get addNoteModalController() {
            var _self = this;

            return function($scope: any, $mdDialog: any, noteType: any, gainsightId: any) {
                $scope.noteType = noteType;
                $scope.gainsightId = gainsightId;
                $scope.newNote = new _self.DealerwareNoteModel({});

                $scope.cancel = function() : void {
                    $mdDialog.hide();
                };

                $scope.saveNote = function() : void {
                    this.newNote.$create({
                        promise: true,
                        params: {
                            location_id: _self.noteCollection.locationId,
                            type: _self.noteCollection.type,
                            model_id: _self.noteCollection.modelId
                        }
                    }).then(
                        function(response: any) {
                            $mdDialog.hide();
                            _self.noteCollection.loadNotes();
                        },
                        function() {
                            alert(_self.labels.errorMessages.generic);
                        }
                    );
                };
            }
        }

        public get useFullScreen() {
            return this.$mdMedia('xs') || this.$mdMedia('sm');
        }

        public openAddNoteModal() : void {
            this.$mdDialog.show({
                templateUrl: '/components/notes/add_note_modal.html',
                controller: this.addNoteModalController,
                locals: {
                    noteType: this.noteCollection.displayType,
                    gainsightId: `${this.gainsightId}-add-note-save`
                },
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: this.useFullScreen
            });
        }

        public translateTitleContent(content: string): string {
            const cnt = content.split(" ");

            const fromState = cnt[3];

            const toState = cnt[5];

            return (this.labels && this.labels.notes && this.labels.navItems)
                ? this.labels.notes.title_content.state_changed_from + " " + this.labels.navItems.vehicles.currentStatus[fromState] + " " + this.labels.notes.title_content.to + " " + this.labels.navItems.vehicles.currentStatus[toState]
                : '';
        }

        public translateNoteContent(content: string): string {
            const cnt = content.split(" ");

            return (this.labels && this.labels.notes)
                ? (cnt[2] === 'is'
                    ? this.labels.notes.note_content.physical_location_is
                    : this.labels.notes.note_content.physical_location_removed)
                : '';
        }
    }

    getDealerwareWebComponentsModule().controller('NotesDirectiveController', NotesDirectiveController);


    export class NotesDirective implements ng.IDirective {

        public restrict         : string    =   'EA';
        public controller       : any       =   'NotesDirectiveController';
        public controllerAs     : string    =   'notesController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            noteCollection: '=',
            gainsightId: '@',
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/notes/notes_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareNotes",() => new NotesDirective());

}
